module.exports = __webpack_public_path__ + "static/feature1-ff52b448ffe74a7643c244bac2cf84c2.jpg";